/* ==========================================================================
  map.js
========================================================================== */

var geocode_place;
var init_complete = false;
var infowindow;

(function($) {



/*
*  new_map
*
*  This function will render a Google Map onto the selected jQuery element
*
*  @type  function
*  @date  8/11/2013
*  @since 4.3.0
*
*  @param $el (jQuery element)
*  @return  n/a
*/

function init_map( $el ) {

  // vars
  var args = {
    zoom              : 16,
    center            : new google.maps.LatLng(0, 0),
    mapTypeId         : google.maps.MapTypeId.ROADMAP,
    mapTypeControl    : false,
    fullscreenControl : false,
    styles            : [{featureType:"administrative",elementType:"labels.text.fill",stylers:[{color:"#000000"}]},{featureType:"landscape",elementType:"all",stylers:[{color:"#f5f5f5"}]},{featureType:"landscape",elementType:"geometry.fill",stylers:[{visibility:"on"},{hue:"#ff0030"}]},{featureType:"landscape.man_made",elementType:"geometry",stylers:[{visibility:"off"}]},{featureType:"landscape.man_made",elementType:"labels",stylers:[{visibility:"off"}]},{featureType:"landscape.natural",elementType:"geometry.fill",stylers:[{lightness:"100"}]},{featureType:"landscape.natural",elementType:"labels",stylers:[{visibility:"off"}]},{featureType:"landscape.natural.landcover",elementType:"geometry.fill",stylers:[{visibility:"on"}]},{featureType:"landscape.natural.terrain",elementType:"geometry",stylers:[{lightness:"100"}]},{featureType:"landscape.natural.terrain",elementType:"geometry.fill",stylers:[{visibility:"off"},{lightness:"23"}]},{featureType:"poi",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"road",elementType:"all",stylers:[{saturation:"-100"},{lightness:45},{weight:"1"}]},{featureType:"road.highway",elementType:"all",stylers:[{visibility:"simplified"}]},{featureType:"road.highway",elementType:"geometry.fill",stylers:[{color:"#ffc72c"},{weight:"2"}]},{featureType:"road.arterial",elementType:"geometry",stylers:[{color:"#c2c2c2"},{lightness:"40"},{weight:"1"}]},{featureType:"road.arterial",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"road.local",elementType:"geometry",stylers:[{visibility:"simplified"},{color:"#c2c2c2"},{lightness:"64"}]},{featureType:"road.local",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"transit",elementType:"all",stylers:[{visibility:"simplified"},{saturation:"-100"},{lightness:"59"}]},{featureType:"transit",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"water",elementType:"all",stylers:[{color:"#ffd900"},{visibility:"on"}]},{featureType:"water",elementType:"geometry.fill",stylers:[{visibility:"on"},{color:"#c2c2c2"},{lightness:"50"}]},{featureType:"water",elementType:"labels",stylers:[{visibility:"off"}]}]
  };


  // create map
  var map = new google.maps.Map($el[0], args);


  // add a markers reference
  map.markers = [];

  infowindow = new google.maps.InfoWindow();

  $.each(markers_from_php, function(index, arr) {
    add_marker(arr, map);
  });

  // center map
  center_map(map);

  // return
  return map;

}

/*
*  add_marker
*
*  This function will add a marker to the selected Google Map
*
*  @type  function
*  @date  8/11/2013
*  @since 4.3.0
*
*  @param $marker (jQuery element)
*  @param map (Google Map object)
*  @return  n/a
*/

function add_marker(marker, map) {

  // var
  var latlng = new google.maps.LatLng(marker.lat, marker.lng);

  // create marker
  var marker = new google.maps.Marker({
    position  : latlng,
    map       : map,
    id        : marker.id,
    category  : marker.category,
    html      : marker.html
  });

  // add to array
  map.markers.push(marker);

  // if marker contains HTML, add it to an infoWindow
  if (marker.html) {

    // create info window
    //var infowindow = new google.maps.InfoWindow({
    //  content : marker.html
    //});

    // show info window when marker is clicked
    google.maps.event.addListener(marker, 'click', function() {
      infowindow.setContent(marker.html);
      infowindow.open(map, this);
      //infowindow.open(map, marker);
    });

  }

}

/*
*  center_map
*
*  This function will center the map, showing all markers attached to this map
*
*  @type  function
*  @date  8/11/2013
*  @since 4.3.0
*
*  @param map (Google Map object)
*  @return  n/a
*/

function center_map( map ) {

  // vars
  var bounds = new google.maps.LatLngBounds();

  // loop through all markers and create bounds
  $.each(map.markers, function( i, marker ){

    var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
    bounds.extend(latlng);

  });

  // only 1 marker?
  if (map.markers.length == 1 ) {
    // set center of map
      map.setCenter( bounds.getCenter() );
      map.setZoom( 16 );
  }
  else {
    // fit to bounds
    map.fitBounds(bounds);
  }

}

/*
*  document ready
*
*  This function will render each map when the document is ready (page has loaded)
*
*  @type  function
*  @date  8/11/2013
*  @since 5.0.0
*
*  @param n/a
*  @return  n/a
*/
// global var
var map = null;

$(document).ready(function() {

  if (typeof markers_from_php !== 'undefined') {

    $('.js-map').each(function() {

      // create map
      map = init_map($(this));


      if ($(this).attr('data-category')) {
        var cat = $(this).attr('data-category');
        setTimeout(function () {
          filter_by_category(cat, window.location.href, true);
        }, 500);

      }

      google.maps.event.addListener(map, 'bounds_changed', function() {
        if (init_complete) {
          update_markers_list(map);
        }

      });

      google.maps.event.addListener(map, 'drag', function() {
        init_complete = true;
      });

      google.maps.event.addListenerOnce(map, 'mousemove', function(){
        google.maps.event.addListener(map, 'zoom_changed', function() {
          init_complete = true;
        });
      });

    });

  }

});

function scroll_to_the_map() {
  $('html, body').animate({
    scrollTop: $("#map").offset().top
  }, 250);
}

/**
 * Go to certain map coordinates
 */
function map_go_to_coordinates(lat, lng) {

  $('.js-locations').addClass('locations--collapsed');
  scroll_to_the_map();

  var latlng = new google.maps.LatLng(lat, lng);
  map.setCenter(latlng);
  map.setZoom(13);
  zoom_out_until_find_markers();

  init_complete = true;
  hide_map_title();


}

/**
 * Zoom out until theres markers
 */
function zoom_out_until_find_markers() {
  var has_markers = false;

  for (var loop = 0; loop < 10; loop++) {
    var found_count = 0;
    for (var i = map.markers.length, bounds = map.getBounds(); i--;) {

      // Hide non-active categories
      if (map.markers[i].getVisible() === false) {
        continue; // ignore invisible
      }

      if (bounds.contains(map.markers[i].getPosition())) {
        found_count++;
        if (found_count >= 2) {
          has_markers = true;
          break;
        }

      }
    }

    if (!Boolean(has_markers)) {
      map.setZoom(map.getZoom() - 1); // No markers for this zoom level, let's zoom out a bit
    } else {
      break; // Found our markers, we're out
    }
  };
}

// Troops search geocomplete
$('.js-map-geocomplete').geocomplete({
  country: $('html').attr('country'),
  language: $('html').attr('lang'),
  // map: map
}).on("geocode:result", function (event, result) {
  setTimeout(function () {
    $('.js-map-submit').click();
  }, 500); // It takes some time for data to be ready, so let's wait 500ms.
  event.preventDefault();
});

$('.js-map-geocomplete').geocomplete().on('geocode:result', function (event, result) {
  geocode_place = result;
});


// Ajax get coords from geocoding (address, zip, city...)
$('.js-map-submit').click(function () {
  try {
    if (geocode_place == null) {
      geocode_place = $('.js-map-geocomplete').geocomplete('find', $('.js-map-geocomplete').val());
    }

    /*
     * Check if user searched a predefined category
     * Turku => 'Turku, Finland'
     * if so, filter by category instead just going to the coordinates
     */
    var search_query_fits_category = false;
    var search_query = $('.js-map-geocomplete').val();
    if (search_query) {
      $('.js-city-link').each(function(index) {
        var $link = $(this);
        var category = $link.attr('data-city');
        if (category) {
          // add comma after category name to not confuse query with cities that share beginning letters
          if (search_query.indexOf(category + ',') == 0) {
            // filter by category and leave early
            search_query_fits_category = true;
            filter_by_category(category, $link.attr('href'), false);
          }
        }
      });
    }

    if (!search_query_fits_category) {
      var coordinates = [];
      coordinates[0] = geocode_place.geometry.location.lat();
      coordinates[1] = geocode_place.geometry.location.lng();
      if ($.isNumeric(coordinates[0]) && $.isNumeric(coordinates[1])) {
        map_go_to_coordinates(coordinates[0], coordinates[1]);
      }
    }

    } catch (err) {
      console.log(err); // api error
    }
});

// Ajax GPS
$('.js-map-gps').click(function () {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function (position) {
      map_go_to_coordinates(position.coords.latitude, position.coords.longitude);
    });
  } else {
    alert('Selaimesi ei tue paikannusta.');
  }
});


/**
 * Close cities
 */
function collapse_cities() {
  $('.js-locations').toggleClass('locations--collapsed')
}
$('.js-collapse-cities').click(function() {
  collapse_cities();
});

/**
 * Filter by category
 */
function filter_by_category(category, href, first_time) {

  // set current url if browser supports history API
  if (!!(window.history && history.pushState) && !first_time) {
    window.history.replaceState(href, document.title, href);
  }

  // vars
  var category_bounds = new google.maps.LatLngBounds();
  var markers_in_category = 0;

  // loop through all markers and create bounds
  $.each(map.markers, function(i, marker) {

    if (marker.category === category) {
      var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
      category_bounds.extend(latlng);
      markers_in_category++;
    }

  });

  if (markers_in_category == 1 ) {
    // set center of map
    map.setCenter(category_bounds.getCenter());
    map.setZoom(15);
  }
  else {
    // fit to bounds
    map.fitBounds(category_bounds);
    // fix map zooming to super close
    if (map.getZoom() > 15) {
      map.setZoom(15);
    }
  }



  // scroll to map
  if (!first_time) {
    scroll_to_the_map();
    hide_map_title();
  } else {

  }

}

function hide_map_title() {
  $('.locations__title').css('display', 'none');
}

  /**
   * Show items in list that correspond with map bounds.
   *
   * @param  map (Google Map object)
   * @return n/a
   */
  function update_markers_list(map) {
    if (init_complete) {
      var id = 0;
      $('.locations__list__item').removeClass('locations__list__item--active');
      $('.locations__list__item').removeClass('locations__list__item--first');

      for (var i=0; i < map.markers.length; i++){
        if(map.markers[i].getVisible() === true && map.getBounds().contains(map.markers[i].getPosition()) ){
          id = map.markers[i].id;
          $('div[data-id="' + id + '"]').addClass('locations__list__item--active');
        }
      }
      $('.locations__list__item--active').first().addClass('locations__list__item--first');
      $('.locations__title').css('display', 'none');
    }
    init_complete = true;


  }

/**
 * City link
 */
//$('.js-city-link').click(function(e) {
//  var category = $(this).attr('data-city');
//  filter_by_category(category, $(this).attr('href'));
//  e.preventDefault();
//})





})(jQuery);
